import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Button, Typography } from '@material-ui/core'
import { Alert, AlertTitle } from '@material-ui/lab'

import { BaseDialog } from 'components'

import helpers from 'helpers'

import useSnackbar from 'hooks/useSnackbar'

import theme from 'theme'
import { routes } from 'Routes'
import useStyles from './styles'
import * as service from 'service'

const AssociationModal = ({ ticketId, setLoading, refresh }) => {
  const [openModal, setOpenModal] = useState(false)
  const [hasData, setHasData] = useState(null)

  const classes = useStyles()
  const snackbar = useSnackbar()

  const handleOpenModal = (option) => {
    setHasData(option)
    setOpenModal((prevState) => !prevState)
  }

  const handleRedirect = () => {
    window.open(
      routes.faqsDocumentations.show.replace(':faqsDocumentationId', '101'),
    )
  }

  const onSubmit = async () => {
    try {
      setLoading(true)

      await service.dponet.titularTickets.confirmData({
        ticketId: ticketId,
        hasTitularData: hasData,
      })

      snackbar.open({
        message: `${
          hasData ? 'Vínculo' : 'Ausência do vínculo'
        } com o titular confirmado com sucesso!`,
        variant: 'success',
      })

      refresh()
      handleOpenModal(null)
    } catch (error) {
      console.error(error)
      snackbar.open({
        message: helpers.formatters.errorMessage(error),
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box className={classes.container}>
      <Typography variant="h6">
        Esta solicitação encontra-se pendente de confirmação de identidade. A
        sua empresa trata os dados desse titular de dados?
      </Typography>
      <Box display="flex" gridGap={theme.spacing(1)}>
        <Button
          variant="outlined"
          color="inherit"
          onClick={() => handleOpenModal(true)}
        >
          Sim
        </Button>
        <Button
          variant="outlined"
          color="inherit"
          onClick={() => handleOpenModal(false)}
        >
          Não
        </Button>
      </Box>
      {openModal && (
        <BaseDialog
          open={openModal}
          setOpen={setOpenModal}
          title={
            hasData
              ? 'Confirme o vínculo com o titular'
              : 'Confirme a ausência do vínculo com o titular'
          }
          dialogActions={
            <Box display="flex" gridGap={theme.spacing(1)}>
              <Button variant="outlined" onClick={() => handleOpenModal(null)}>
                Cancelar
              </Button>
              <Button variant="contained" color="primary" onClick={onSubmit}>
                Confirmar
              </Button>
            </Box>
          }
        >
          <Box className={classes.modalContent}>
            <Typography
              component="div"
              dangerouslySetInnerHTML={{
                __html: hasData
                  ? 'Você está confirmando que a sua empresa <strong>trata</strong> os dados deste titular. Ao prosseguir, será registrada a <strong>associação</strong> entre sua empresa e este titular de dados.'
                  : 'Você está informando que sua empresa <strong>não realiza o tratamento</strong> dos dados deste titular. Ao prosseguir, será registrada a <strong>ausência de associação</strong> entre sua empresa e este titular de dados.',
              }}
            />
            <Alert severity="info">
              <AlertTitle>Verificação de dados</AlertTitle>
              <Typography variant="body2" gutterBottom>
                Entre em contato com o responsável pela base de dados e confirme
                se essas informações são compatíveis ou não com a base de dados
                dentro da sua empresa.
              </Typography>
              Para mais informações, consulte a nossa&nbsp;
              <strong onClick={handleRedirect} className={classes.link}>
                Central de Ajuda
              </strong>
              .
            </Alert>
          </Box>
        </BaseDialog>
      )}
    </Box>
  )
}

AssociationModal.propTypes = {
  ticketId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  setLoading: PropTypes.func.isRequired,
  refresh: PropTypes.func.isRequired,
}

export default AssociationModal
